import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { defineCustomElements } from '@eon-ui/eon-ui-components/loader';
import { AppComponent } from './app/component/root/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

defineCustomElements(); // this registers the E.ON UI components in the browser
